<div class="nav-menu-v3__list">
	@for (item of items; track item.id) {
		<ng-container>
			<ng-container *ngTemplateOutlet="(item.route ? routerLinkButton : sectionPanel); context: { nav: item }"></ng-container>

			@if (item.divider) {
				<div class="nav-menu-v3__item-divider"></div>
			}
		</ng-container>
	}
</div>

<!-- Leaf item: icon + label -->
<ng-template #routerLinkButton let-item="nav">
	<ng-container *minePermissions="item.permittedRoles">
		<a
			class="nav-menu-v3__item"
			[class.nav-menu-v3__item--active]="isLeafActive(item)"
			routerLink="/{{ item.route }}"
			(click)="onItemClick(item)"
		>
			<ng-container *ngTemplateOutlet="btnContent; context: { navItem: item }"></ng-container>
		</a>
	</ng-container>
</ng-template>

<!-- Collapsible section: muted header (title + chevron) + leaf children.
     Visibility is decided by isItemVisible() in initItems() — a section shows when at least one
     child is permitted. Deliberately NOT also gated by *minePermissions on the section's own
     menu-id roles: that veto hid whole sections from roles the menu-id default omits (CmpAdmin
     was never in it), taking permitted children like Consent down with them. -->
<ng-template #sectionPanel let-item="nav">
	<mine-expansion-panel #subMenu class="nav-menu-v3__section noPadding" [isOpen]="shrink || item.active" (stateChanged)="onSectionToggle(item, $event)">
		<p class="nav-menu-v3__section-header" [class.nav-menu-v3__section-header--open]="item.active" (click)="onItemClick(item)" header>
			<span class="nav-menu-v3__section-title">{{ item.title }}</span>
			<svg class="nav-menu-v3__section-chevron" [class.nav-menu-v3__section-chevron--open]="item.active">
				<use xlink:href="../../../assets/img/sprite.svg#icon-next-arrow"></use>
			</svg>
		</p>
		<div class="nav-menu-v3__accordion" content>
			@for (s of item.subMenu; track s.id) {
				<ng-container *ngTemplateOutlet="routerLinkButton; context: { nav: s }"></ng-container>
			}
		</div>
	</mine-expansion-panel>
</ng-template>

<ng-template #btnContent let-item="navItem">
	@let newIcon = iconName(item);
	@if (newIcon) {
		<i mine-icon [name]="newIcon" size="s" class="nav-menu-v3__icon" [tp]="item.title" [tpIsEnabled]="shrink" [tpPlacement]="tpProps.placement"></i>
	} @else if (item.icon) {
		<svg class="nav-menu-v3__icon" [tp]="item.title" [tpIsEnabled]="shrink" [tpPlacement]="tpProps.placement">
			<use [attr.xlink:href]="'../../../assets/img/sprite.svg#' + item.icon"></use>
		</svg>
	}
	<span class="nav-menu-v3__title">{{ item.title }}</span>

	@let pimpleData = pimpleMap?.get(item.id) | async;
	@if (pimpleData) {
		<span class="nav-menu-v3__pimple" [@pimple] [ngStyle]="{ backgroundColor: item.pimple.bgColor }"></span>
	}
</ng-template>
